export default {
	messages: {
		de: {
			dateInvalid: 'Ungültiges Datum!',
		},
		en: {
			dateInvalid: 'Invalid date!',
		},
	},
};
